class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    if (this.id == 'cart-items' && document.querySelector('cart-drawer-items')) return;
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (!input) return;
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (event.target.id.includes('quickadd')) return;

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (document.querySelector('#CartDrawer')) {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['.drawer__inner'];
          for (const selector of selectors) {
            const originalDiscountDetails = document.querySelector('cart-drawer .cart-discount details');
            const originalNoteDetails = document.querySelector('#Details-CartDrawer');
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);

              requestAnimationFrame(() => {
                const discountDetails = document.querySelector('cart-drawer .cart-discount details');
                const noteDetails = document.querySelector('#Details-CartDrawer');

                if (discountDetails) {
                  if (originalDiscountDetails && originalDiscountDetails.hasAttribute('open')) {
                    discountDetails.setAttribute('open', true);
                  }
                  if (!discountDetails.classList.contains('loaded')) {
                    closingAccordions('cart-drawer .cart-discount details');
                  }
                }

                if (noteDetails) {
                  if (originalNoteDetails && originalNoteDetails.hasAttribute('open')) {
                    noteDetails.setAttribute('open', true);
                  }
                  if (!noteDetails.classList.contains('loaded')) {
                    closingAccordions('#Details-CartDrawer');
                  }
                }
              });
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    if (document.getElementById('cart-items')) {
      fetch(`${routes.cart_url}?section_id=${document.getElementById('cart-items')?.dataset.id}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');

          document.getElementById('cart-items').innerHTML = sourceQty.innerHTML;
          document.getElementById('cart-items').classList = sourceQty.classList;
        })
        .catch((e) => {
          console.error(e);
        });
    }

    if (document.getElementById('main-cart-footer')) {
      fetch(`${routes.cart_url}?section_id=${document.getElementById('main-cart-footer')?.dataset.id}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const originalDiscountDetails = document.querySelector('#main-cart-footer .cart-discount details');
          const sourceQty = html.querySelector('#main-cart-footer');

          document.getElementById('main-cart-footer').innerHTML = sourceQty.innerHTML;
          document.getElementById('main-cart-footer').classList = sourceQty.classList;

          requestAnimationFrame(() => {
            const discountDetails = document.querySelector('#main-cart-footer .cart-discount details');

            if (discountDetails) {
              if (originalDiscountDetails && originalDiscountDetails.hasAttribute('open')) {
                discountDetails.setAttribute('open', true);
              }
              if (!discountDetails.classList.contains('loaded')) {
                closingAccordions('#main-cart-footer .cart-discount details');
              }
            }
          });
        })
        .catch((e) => {
          console.error(e);
        });
    }

    if (document.getElementById('cart-featured-collection')) {
      fetch(`${routes.cart_url}?section_id=${document.querySelector('#cart-featured-collection').dataset.id}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('#cart-featured-collection');
          document.querySelector('#cart-featured-collection').innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    const sectionsToRender = [];
    if (document.getElementById('cart-items')) {
      sectionsToRender.push({
        id: `shopify-section-${document.getElementById('cart-items')?.dataset.id}`,
        section: document.getElementById('cart-items')?.dataset.id,
        selector: '#cart-items',
      });
    }
    if (document.getElementById('cart-icon-bubble')) {
      sectionsToRender.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      });
    }
    if (document.getElementById('main-cart-footer')) {
      sectionsToRender.push({
        id: `shopify-section-${document.getElementById('main-cart-footer')?.dataset.id}`,
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '#main-cart-footer',
      });
    }
    if (document.getElementById('CartDrawer')) {
      sectionsToRender.push({
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      });
    }
    if (document.getElementById('cart-navigation')) {
      sectionsToRender.push({
        id: 'cart-navigation',
        section: document.getElementById('cart-navigation')?.dataset.id,
        selector: '#CartNavigation-cart-item',
      });
    }
    if (document.getElementById('cart-featured-collection')) {
      sectionsToRender.push({
        id: 'cart-featured-collection',
        section: document.getElementById('cart-featured-collection')?.dataset.id,
        selector: '#cart-featured-collection',
      });
    }
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    let parsedState;
    const body = JSON.stringify({
      line,
      quantity,
      sections_url: routes.cart_url,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        parsedState = JSON.parse(state);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((error) => {
        console.error(error);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        const items = document.querySelectorAll('.cart-item');
        this.renderSections(line, parsedState, items);
      });
  }

  renderSections(line, parsedState, items) {
    fetch(`${routes.cart_url}`)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          const originalDiscountDetails = document.querySelector('cart-drawer .cart-discount details');
          const originalNoteDetails = document.querySelector('#Details-CartDrawer');
          if (!elementToReplace) return;
          const elementReplacement =
            responseHTML.getElementById(section.id).querySelector(section.selector) ||
            responseHTML.getElementById(section.id);

          elementToReplace.innerHTML = elementReplacement.innerHTML;
          if (section.id != 'cart-icon-bubble') elementToReplace.classList = elementReplacement.classList;

          if (section.id == 'CartDrawer') {
            requestAnimationFrame(() => {
              const discountDetails = document.querySelector('cart-drawer .cart-discount details');
              const noteDetails = document.querySelector('#Details-CartDrawer');

              if (discountDetails) {
                if (originalDiscountDetails && originalDiscountDetails.hasAttribute('open')) {
                  discountDetails.setAttribute('open', true);
                }
                if (!discountDetails.classList.contains('loaded')) {
                  closingAccordions('cart-drawer .cart-discount details');
                }
              }

              if (noteDetails) {
                if (originalNoteDetails && originalNoteDetails.hasAttribute('open')) {
                  noteDetails.setAttribute('open', true);
                }
                if (!noteDetails.classList.contains('loaded')) {
                  closingAccordions('#Details-CartDrawer');
                }
              }
            });
          }
        });

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const mainSideCart = document.querySelector('.main-side-cart');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        if (mainSideCart) mainSideCart.classList.toggle('main-side-cart--empty', parsedState.item_count === 0);

        if (parsedState.errors) {
          this.updateLiveRegions(line, parsedState.errors);
          this.disableLoading(line);
          return;
        }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          // cartDrawerWrapper
          //   ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
          //   : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          if (!cartDrawerWrapper.querySelector('.drawer__inner-empty') || !cartDrawerWrapper.querySelector('a')) {
            // trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          }
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionElement(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });

            const cartNotes = Array.from(document.querySelectorAll('cart-note')).filter((note) => note != this);
            cartNotes.forEach(note => {
              note.querySelector('textarea').value = event.target.value;
            })
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
